import React, { Component } from 'react';

export class StaticBreadcrumb extends Component {
    static displayName = StaticBreadcrumb.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        let content = this.props.content;

        return (
            <nav className='static-breadcrumb-wrap' aria-label="Breadcrumb">
                <div className='static-breadcrumb'>
                    {content}
                </div>
            </nav>  
        );
    }
}

export default StaticBreadcrumb;
